import { Icon } from '@iconify/react';
import {useState} from 'react';
import SimplDropDownRow from './SimplDropDownRow';

function App(props) {

  const [isOpen, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [highlightedValue, setHighlightedValue] = useState('');
  const [editRefs, setEditRefs] = useState({});


  var clickItemInSelect = props.clickItemInSelect;
  var optionsIn = props.options;
  var isSortedAlphabetically = props.isSortedAlphabetically;

  var options;
  if (isSortedAlphabetically){
    options = optionsIn.sort(compare);
  }else{
    options = optionsIn;
  }
  var currentAnswer = props.currentAnswer;

  function compare(a, b) {
    if (a.n < b.n) {
      return -1;
    }
    if (a.n > b.n) {
      return 1;
    }
    // a must be equal to b
    return 0;
  }

  function clickItem(item){
    return function(e){
      var addChangesFn = false;
      for (var i = 0; i < options.length; i++){
        if (item.i === options[i].i){
          addChangesFn = options[i].addChangesFn;
        }
      }
     clickItemInSelect(item.i, addChangesFn);
      setOpen(!isOpen);
    }
  }

    var txt = '';
    var iconA = null;
    var validChoices = options.filter((anI, index)=>{
      if (!isOpen){
        return true;
      }else{
        if (anI.n.toLowerCase().indexOf(searchValue.toLowerCase()) > -1){
          return true;
        }else if (searchValue.length === 0){
          return true;
        }
        return false;
      }
    })

    var whichHighlight = -1;

    var inputslist = validChoices.map((anI, index)=>{

//          

      var icon;
      if (anI.img){
        icon = <img src={anI.img} style={{width:'20px'}} alt={anI.n}/>
      }else if (anI.a){
        icon = <Icon icon={anI.a} />
      }
      if (anI.i === currentAnswer){
        txt = anI.n;
        iconA = icon;
      }

      var highlightStyle = {};
      if (anI.i === highlightedValue){
        whichHighlight = index;
        // if (isDark){
        //   highlightStyle.backgroundColor = '#888';
        // }else{
          highlightStyle.backgroundColor = '#52c4a4';
        // }
      }

      return <SimplDropDownRow onClick={clickItem(anI)} editRefs={editRefs} setEditRefs={setEditRefs} nos={+index} style={highlightStyle} items={[icon, spaces(icon, anI.n), anI.n]} />
//
    })

    function spaces(iconA, text){
      if (iconA && text){
        return <span>&nbsp;&nbsp;</span>
      }
      return null;
    }
//    
    function toggleDropdown(){
      if (!isOpen){
        setSearchValue('');
        setHighlightedValue(currentAnswer);
        setTimeout(function(){ 
          for (var i = 0; i < options.length; i++){
            var anI = options[i];
            if (anI.i === currentAnswer){
              var myRef1 = editRefs[i];
              if (myRef1){
                myRef1.current.scrollIntoView({ behavior: 'smooth' , block: 'nearest', inline: 'start' });
              }            
            }
          }
        }, 1);
      }
      setOpen(!isOpen);
    }

    function onChange(e){
      setSearchValue(e.target.value);
      e.stopPropagation();
    }

    function nothingFn(e){
      e.stopPropagation();
    }

//
    var mainLine;
    if (isOpen){

      function onInputKeyDown(e){
        var newNos;
        if (e.keyCode === 13){
          if (whichHighlight > -1){
            clickItem(validChoices[whichHighlight])();
          }else if (validChoices.length > 0){
            clickItem(validChoices[0])();
          }
        }else if (e.keyCode === 40){ //go down
          if (validChoices.length > 0){
            if (whichHighlight + 1 < validChoices.length){
              newNos = whichHighlight + 1;
            }else{
              newNos = 0;
            }
            setHighlightedValue(validChoices[newNos].i);

            var myRef1 = editRefs[newNos];
            if (myRef1){
              myRef1.current.scrollIntoView({ behavior: 'smooth' , block: 'nearest', inline: 'start' });
            }            

          }else{
            setHighlightedValue('');
          }
        }else if (e.keyCode === 38){ //go up
          if (validChoices.length > 0){
            if (whichHighlight - 1 > -1){
              newNos = whichHighlight - 1;
            }else{
              newNos = validChoices.length - 1;
            }
            setHighlightedValue(validChoices[newNos].i);

            var myRef = editRefs[newNos];
            if (myRef){
              myRef.current.scrollIntoView({ behavior: 'smooth' , block: 'nearest', inline: 'start' });
            }            
          }else{
            setHighlightedValue('');
          }

        }
      }  

      var inputStyle ={border:'none', outline:'none', boxShadow:'none'};
        inputStyle.color = 'white';
        inputStyle.backgroundColor = '#4397a1';
    mainLine =  <div className='dropdownTextT'><input autoFocus type='text' className='form-control insetInput dropdownInputT' onChange={onChange} placeholder='' value={searchValue} onClick={nothingFn} onKeyDown={onInputKeyDown} style={inputStyle}/></div>
//
    }else{
      var toShow = txt;
      if (!toShow){
        toShow = 'Click to Select from Options';
      }


      mainLine =  <div className='dropdownTextT'>{iconA}{spaces(iconA, toShow)}{toShow}</div>
    }
//
  var bodyStyle = {padding:'10px', textAlign:'left'};
//
    return <div className={'dropdownMainBodyT ' + (isOpen && 'open')} onClick={toggleDropdown}>
      <div className='dropdownHeaderT' >
        {mainLine}
        <div className={'dropdownIconT ' + (isOpen && 'open')}><Icon icon='ep:arrow-right-bold' height='13px'/></div>
      </div>
      <div className={'dropdownBodyT ' + (isOpen && 'open')} style={bodyStyle} >
        {inputslist}
      </div>
    </div>
}


//
export default App;
